import axios from "axios";

export const state = {
    reportcashiersprofits: [],
};

export const getters = {
    reportcashiersprofits: state => state.reportcashiersprofits,
};

export const mutations = {
    setReportCashiersProfit(reportcashiersprofits, newValue) { state.reportcashiersprofits = newValue},
};

export const actions = {
    fetchReportCashiersProfit({ commit }) {
        axios.get('/reportcashiersprofits').then(res => {
            commit('setReportCashiersProfit', res.data.profits)
        })
    },
    filterReportCashiersProfit({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportcashiersprofits";
        axios.post(url, formData).then((response) => {
            commit('setReportCashiersProfit', response.data.profits)
        })
    },
};
